@import '~style-sheet-helpers/core.less';
@import (reference) '../../../style.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@fontSize: 13px;

.component-header,
.bundle-component {
  display: grid;
  grid-template-columns: 200px 300px 225px 50px;
  font-size: @fontSize;
  border: 1px solid @product-page--variants--border-color;
  border-bottom: 0;
  > div {
    padding: 5px;
  }
}

.bundle-component {
  border-right: 1px solid @product-page--variants--border-color;
  border-left: 1px solid @product-page--variants--border-color;
  &:last-child {
    border-bottom: 1px solid @product-page--variants--border-color;
  }
  &.centered {
    justify-content: center;
  }
}

.components {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0 20px;
}

.component-title {
  padding-bottom: 10px;
  border-bottom: 1px solid @product-page--variants-title--border-color;
}

.component-wrapper {
  padding: 20px 0;
}

.component-header,
.component-footer {
  background-color: @product-page--variants--background-color;
  font-weight: 500;
}

.component-footer {
  display: grid;
  grid-template-columns: 200px 300px 225px 50px;
  border: 1px solid @product-page--variants--border-color;
  > div {
    padding: 5px;
  }
}

.auto-complete-dropdown {
  min-width: 300px;
  max-width: 300px;
  max-height: 160px;
  overflow: auto;
}

.add-component {
  text-align: center;
}

.quantity-input {
  align-self: normal;
  height: 34px;
}

.quantity {
  text-align: center;
}

.icon-container {
  height: 34px;
  width: 100%;
  justify-content: center;
}

.delete-button {
  height: 34px;
  align-self: normal;
  > svg {
    fill: var(--default--icon--fill-color--11);
    width: 16px;

    > path {
      stroke-width: 1px;
    }
  }
}

.input {
  align-self: normal;
  width: 100%;

  > input {
    height: 34px;
  }
}

.options-plus-add {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px 5px;
}
